<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
       <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/projectmanagement/index">Project Management</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
       Create Project
      </h6>

      <div class="container-fluid" style="padding-bottom: 140px;">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start flex-wrap mb-3">
              <div>
                <h5 class="mb-1">Create Project</h5>
              </div>
            </div>

            <form @submit.prevent="saveProject">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="custom-label" style="font-size: small;">Select Sponsor</label>
                    <select v-model="form.person" class="form-control bdr-rad font-size_def" required>
                      <option value="">- Select Sponsor -</option>
                      <option v-for="item in people" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="custom-label" style="font-size: small;">Project Name</label>
                    <input
                      v-model="form.project_name"
                      type="text"
                      class="form-control bdr-rad font-size_def"
                      placeholder="Enter project name"
                      required
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Project Description</label>
                    <textarea
                      v-model="form.project_description"
                      class="form-control bdr-rad font-size_def"
                      rows="2"
                      placeholder="Enter project description"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="custom-label" style="font-size: small;">Select Site</label>
                    <select v-model="form.site" class="form-control bdr-rad font-size_def" required>
                      <option value="">- Select Site -</option>
                      <option v-for="item in sites" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Select CRC</label>
                    <select v-model="form.crc" class="form-control bdr-rad font-size_def">
                      <option value="">- Select CRC -</option>
                      <option v-for="item in crcOptions" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Select Investigators</label>
                    <v-select
                      v-model="form.investigator"
                      :options="availableInvestigatorOptions"
                      label="label"
                      class="font-size_def activity-select"
                      multiple
                      placeholder="- Select Investigator -"
                    >
                      <template #selected-option-container></template>
                    </v-select>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Select Investigator Team</label>
                    <div class="team-checkbox-box">
                      <div
                        v-for="item in selectedInvestigatorOptions"
                        :key="item.value"
                        class="d-flex align-items-center mb-2 team-checkbox-item"
                      >
                        <button
                          type="button"
                          class="btn btn-link btn-sm activity-remove-btn"
                          aria-label="Remove investigator"
                          @click="removeInvestigator(item.value)"
                        >
                          X
                        </button>
                        <div class="form-check-label" style="font-size: small;">
                          {{ item.label }}
                        </div>
                      </div>
                      <div v-if="!selectedInvestigatorOptions.length" class="text-muted" style="font-size: small;">
                        Selected investigators will appear here.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Number of Visits</label>
                    <input
                      v-model.number="form.number_of_visit"
                      type="number"
                      min="0"
                      class="form-control bdr-rad font-size_def"
                      placeholder="Enter number of visit"
                    />
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Screening Date</label>
                    <DatePicker
                      :value="form.screening_date"
                      value-type="YYYY-MM-DD"
                      format="DD/MM/YYYY"
                      class="project-date-picker font-size_def"
                      input-class="form-control bdr-rad font-size_def"
                      placeholder="dd/mm/yyyy"
                      style="width: 100%;"
                      @input="form.screening_date = $event"
                    />
                  </div>
                </div>
              </div>

              <div class="card custom_bdr_rds shadow p-2 mt-2">
                <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>Visit Schedule</b></h6>
                  <div class="table-responsive">
                    <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                      <thead class="background_color2">
                        <tr class="custom-label2">
                          <th style="width: 8%;">#</th>
                          <th style="width: 16%;">Treatment Phase</th>
                          <th style="width: 38%;">Description</th>
                          <th style="width: 18%;">Date</th>
                          <th style="width: 20%;">Allowed Deviation +/- Days</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(visit, index) in form.visit_schedule" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <input
                              v-if="!visit.is_fixed_row"
                              v-model.number="visit.treatment_phase"
                              @input="updateVisitDate(index)"
                              type="number"
                              min="0"
                              class="form-control bdr-rad font-size_def"
                              placeholder="Enter treatment phase"
                            />
                            <div v-else class="form-control bdr-rad font-size_def bg-white">
                              {{ visit.treatment_phase_label }}
                            </div>
                          </td>
                          <td>
                            <input
                              v-model="visit.description"
                              type="text"
                              class="form-control bdr-rad font-size_def"
                              placeholder="Enter description"
                            />
                          </td>
                          <td>
                            <DatePicker
                              v-if="visit.is_fixed_row"
                              :value="visit.date"
                              value-type="YYYY-MM-DD"
                              format="DD/MM/YYYY"
                              class="project-date-picker font-size_def"
                              input-class="form-control bdr-rad font-size_def"
                              placeholder="dd/mm/yyyy"
                              style="width: 100%;"
                              @input="visit.date = $event"
                            />
                            <DatePicker
                              v-else
                              :value="visit.date"
                              value-type="YYYY-MM-DD"
                              format="DD/MM/YYYY"
                              class="project-date-picker font-size_def"
                              input-class="form-control bdr-rad font-size_def"
                              style="width: 100%;"
                              :clearable="false"
                              :editable="false"
                              :disabled="true"
                            />
                          </td>
                          <td>
                            <input
                              v-model="visit.allowed_deviation_days"
                              type="text"
                              class="form-control bdr-rad font-size_def"
                              placeholder="+/- days"
                            />
                          </td>
                        </tr>
                        <tr v-if="!form.visit_schedule.length">
                          <td colspan="5" class="text-center text-muted py-3">
                            Select number of visit to generate rows.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div v-if="previewMessage" class="alert alert-success mt-4 mb-0" role="alert">
                {{ previewMessage }}
              </div>

              <div style="border-bottom: 0px; padding-top: 0px;" class="navbar mt-3">
                <div class="d-flex"></div>
                <div class="d-flex">
                  <button
                    type="button"
                    class="mr-1 btn btn-outline-secondary mb-1 font-size_def bdr-rad"
                    @click="resetForm"
                  >
                    Clear
                  </button>
                  <button type="submit" class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad">
                    Create Project
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

function createForm() {
  return {
    person: "",
    project_name: "",
    project_description: "",
    site: "",
    crc: "",
    investigator: [],
    number_of_visit: "",
    allowed_deviation_days: "",
    screening_date: "",
    visit_schedule: [],
  };
}

export default {
  components: {
    DatePicker,
    vSelect,
    TopNavbar,
    ContentFooter,
  },

  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
      form: createForm(),
      previewMessage: "",
      people: [],
      sites: [],
      crcOptions: [],
      investigatorOptions: [],
    };
  },

  computed: {
    availableInvestigatorOptions() {
      const selectedValues = new Set(this.form.investigator.map((item) => item.value));

      return this.investigatorOptions.filter((item) => !selectedValues.has(item.value));
    },

    selectedInvestigatorOptions() {
      return this.form.investigator;
    },
  },

  mounted() {
    this.loadCustomers();
    this.loadServiceTechnicians();
    this.loadInvestigators();
  },

  methods: {
    async loadCustomers() {
      try {
        const { data } = await axios.get("/mcustomer/index?page=1&limit=1000", {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        const customers = Array.isArray(data.item_list) ? data.item_list : [];
        this.people = customers.map((customer) => ({
          label: customer.C_name,
          value: customer.idCustomer,
        }));

        const uniqueSites = [];
        const seenSites = new Set();

        customers.forEach((customer) => {
          const siteName = customer && customer.C_address_line3 ? String(customer.C_address_line3).trim() : "";

          if (siteName && !seenSites.has(siteName.toLowerCase())) {
            seenSites.add(siteName.toLowerCase());
            uniqueSites.push({
              label: siteName,
              value: siteName,
            });
          }
        });

        this.sites = uniqueSites;
      } catch (error) {
        console.log(error.response || error);
      }
    },

    async loadServiceTechnicians() {
      try {
        const { data } = await axios.get("/mservicetechnician/index", {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        const technicians = Array.isArray(data.all_data) ? data.all_data : [];
        this.crcOptions = technicians.map((technician) => ({
          label: technician.name1,
          value: technician.id,
        }));
      } catch (error) {
        console.log(error.response || error);
      }
    },

    async loadInvestigators() {
      try {
        const { data } = await axios.get("/investigator/index", {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        const investigators = Array.isArray(data.all_data) ? data.all_data : [];
        this.investigatorOptions = investigators.map((investigator) => ({
          label: investigator.name,
          value: investigator.id,
        }));
      } catch (error) {
        console.log(error.response || error);
      }
    },

    resetForm() {
      this.form = createForm();
      this.previewMessage = "";
    },

    removeInvestigator(value) {
      this.form.investigator = this.form.investigator.filter((investigator) => investigator.value !== value);
    },

    normalizeDeviationValue(value) {
      if (value === null || typeof value === "undefined") {
        return "";
      }

      const normalized = String(value).trim();

      if (!normalized) {
        return "";
      }

      const parsed = parseInt(normalized, 10);

      if (Number.isNaN(parsed)) {
        return "";
      }

      if (normalized.startsWith("+")) {
        return `+${Math.abs(parsed)}`;
      }

      if (normalized.startsWith("-")) {
        return `-${Math.abs(parsed)}`;
      }

      return `+/- ${Math.abs(parsed)}`;
    },

    formatVisitDate(screeningDate, treatmentPhase) {
      if (!screeningDate && screeningDate !== 0) {
        return "";
      }

      if (treatmentPhase === "" || treatmentPhase === null || typeof treatmentPhase === "undefined") {
        return "";
      }

      const offset = Number(treatmentPhase);

      if (!Number.isFinite(offset) || offset < 0) {
        return "";
      }

      const baseDate = new Date(screeningDate + "T00:00:00");

      if (Number.isNaN(baseDate.getTime())) {
        return "";
      }

      baseDate.setDate(baseDate.getDate() + offset);

      const year = baseDate.getFullYear();
      const month = String(baseDate.getMonth() + 1).padStart(2, "0");
      const day = String(baseDate.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    createVisitScheduleRow(overrides = {}) {
      return {
        treatment_phase: "",
        treatment_phase_label: "",
        is_fixed_row: false,
        description: "",
        date: "",
        allowed_deviation_days: this.normalizeDeviationValue(this.form.allowed_deviation_days),
        ...overrides,
      };
    },

    createVisitScheduleRows(count) {
      const dynamicRows = Array.from({ length: count }, () => this.createVisitScheduleRow());
      const fixedRows = [
        this.createVisitScheduleRow({
          is_fixed_row: true,
          treatment_phase: null,
          treatment_phase_label: "End of Study",
        }),
        this.createVisitScheduleRow({
          is_fixed_row: true,
          treatment_phase: null,
          treatment_phase_label: "Safety Follow-up Visit",
        }),
      ];

      return [...dynamicRows, ...fixedRows];
    },

    updateVisitDate(index) {
      const visit = this.form.visit_schedule[index];

      if (!visit || visit.is_fixed_row) {
        return;
      }

      this.$set(visit, "date", this.formatVisitDate(this.form.screening_date, visit.treatment_phase));
    },

    syncVisitScheduleDates() {
      this.form.visit_schedule.forEach((visit, index) => {
        this.updateVisitDate(index);
      });
    },

    async saveProject() {
      this.previewMessage = "";

      try {
        const payload = {
          userid: this.userid,
          form: {
            person: this.form.person,
            project_name: this.form.project_name,
            project_description: this.form.project_description,
            site: this.form.site,
            crc: this.form.crc,
            investigator: this.form.investigator.map((investigator) => investigator.value),
            screening_date: this.form.screening_date,
            number_of_visit: this.form.number_of_visit,
            visit_schedule: this.form.visit_schedule.map((visit) => ({
              ...visit,
              allowed_deviation_days: this.normalizeDeviationValue(visit.allowed_deviation_days),
            })),
          },
        };

        const { data } = await axios.post("/projectmanagement/create", payload, {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (data.status === 200) {
          this.resetForm();
          this.previewMessage = "Project saved successfully.";
        } else {
          this.previewMessage = data.message || "Project save failed.";
        }
      } catch (error) {
        console.log(error.response || error);
        this.previewMessage = "Project save failed.";
      }
    },
  },

  watch: {
    "form.screening_date"() {
      this.syncVisitScheduleDates();
    },
    "form.number_of_visit"(value) {
      const count = Number(value) || 0;
      this.form.visit_schedule = this.createVisitScheduleRows(count);
      this.syncVisitScheduleDates();
    },
    "form.allowed_deviation_days"(value) {
      this.form.visit_schedule = this.form.visit_schedule.map((visit) => ({
        ...visit,
        allowed_deviation_days: this.normalizeDeviationValue(value),
      }));
    },
  },
};
</script>

<style scoped>
.team-checkbox-box {
  border: 1px solid #ced4da;
  border-radius: 12px;
  background: #ffffff;
  padding: 10px 12px;
  min-height: 120px;
}

.team-checkbox-item:last-child {
  margin-bottom: 0 !important;
}

.project-date-picker >>> .mx-input {
  font-size: small;
}

.screening-date-box {
  width: 100%;
  max-width: 240px;
}

.activity-remove-btn {
  font-size: 11px;
  padding: 2px 8px 2px 0;
  border: 0;
  color: #dc3545;
  text-decoration: none;
}

.activity-select >>> .vs__selected {
  display: none;
}

.activity-select >>> .vs__dropdown-toggle {
  min-height: 37px;
  padding: 0 6px;
  font-size: 12px;
}

.activity-select >>> .vs__search,
.activity-select >>> .vs__selected-options,
.activity-select >>> .vs__actions,
.activity-select >>> .vs__open-indicator,
.activity-select >>> .vs__search::placeholder {
  font-size: 12px;
}

.activity-select >>> .vs__search {
  padding: 2px 4px;
  margin: 0;
  line-height: 1.2;
}

.activity-select >>> .vs__actions {
  padding: 0 4px 0 0;
}
</style>
